import { ReactComponent as Dashboardicon } from "svgs/light/dashboard.svg";
import { ReactComponent as DashboardFillicon } from "svgs/light/dashboard-fill.svg";

import { ReactComponent as EmployeesIcon } from "svgs/light/employess.svg";
import { ReactComponent as EmployeesFillIcon } from "svgs/light/employees-solid.svg";

import { ReactComponent as JobsOutlineIcon } from "svgs/light/jobs-outline.svg";
import { ReactComponent as JobsFillIcon } from "svgs/light/jobs-solid.svg";

import { ReactComponent as HolidayIcon } from "svgs/light/holidays.svg";
import { ReactComponent as LeavesIcon } from "svgs/light/leaves.svg";
import { ReactComponent as LeavesFillIcon } from "svgs/light/leaves-solid.svg";

import { ReactComponent as Transport } from "svgs/light/vehicle-light.svg";
import { ReactComponent as TransportFillIcon } from "svgs/light/transport-selected.svg";

import { ReactComponent as ScheduleManagement } from "svgs/light/schedule-management.svg";
import { ReactComponent as ScheduleManagementFill } from "svgs/light/schedule-management-selected.svg";

import { ReactComponent as EmployeeIcon } from "svgs/light/employee.svg";
import { ReactComponent as EmployeeFillIcon } from "svgs/light/employee-solid.svg";

import { ReactComponent as NoticeBoardActive } from "svgs/light/noticeboardactive.svg";
import { ReactComponent as NoticeBoardInactive } from "svgs/light/noticeboard.svg";
import { ReactComponent as RoomsIcon } from "svgs/light/message.svg";
import { ReactComponent as RoomsFillIcon } from "svgs/light/message-fill.svg";
import { ReactComponent as AcxioHubIcon } from "svgs/light/acxio-hub.svg";
import { ReactComponent as AcxioHubFillIcon } from "svgs/light/acxio-hub-fill.svg";

// configs
import { PATH_NAME, DRAWER_MENU_LABEL } from "configs";
import { ReactComponent as attendanceIcon } from "svgs/light/attendanceIcon.svg";
import { ReactComponent as attendanceFillIcon } from "svgs/light/attendance-filledIcon.svg";

import { ReactComponent as InventoryIcon } from "svgs/light/inventory-outlined-icon.svg";
import { ReactComponent as InventoryFillIcon } from "svgs/light/inventory-fill-icon.svg";

import { ReactComponent as TicketsIcon } from "svgs/light/tickets.svg";
import { ReactComponent as TicketsFillIcon } from "svgs/light/tickets-selected.svg";

import { ReactComponent as FilesIcon } from "svgs/light/files.svg";
import { ReactComponent as FilesFillIcon } from "svgs/light/files-solid.svg";

import { ReactComponent as UserPermissionIcon } from "svgs/light/user-permission.svg";
import { ReactComponent as UserPermissionFillIcon } from "svgs/light/user-permissions-fill.svg";

import { ReactComponent as AccessIcon } from "svgs/light/access.svg";
import { ReactComponent as AccessFillIcon } from "svgs/light/access-filled.svg";

import { ReactComponent as WorkUpdateIcon } from "svgs/light/work-update.svg";
import { ReactComponent as WorkUpdateFillIcon } from "svgs/light/work-update-fill.svg";

import { ReactComponent as JobManagementIcon } from "svgs/light/job-management.svg";
import { ReactComponent as JobManagementFillIcon } from "svgs/light/job-management-fill.svg";

import { ReactComponent as UserTrackingIcon } from "svgs/light/UserTrackingIcon.svg";
import { ReactComponent as UserTrackingFillIcon } from "svgs/light/filled-user-tracking-icon.svg";

import { ReactComponent as UserInviteFillIcon } from "svgs/light/user-add-active.svg";
import { ReactComponent as UserInviteIcon } from "svgs/light/user-invite-inactive.svg";

import { ReactComponent as GapAnalysisIcon } from "svgs/light/GapAnalysis/gap-analysis-icon.svg";
import { ReactComponent as GapAnalysisFillIcon } from "svgs/light/GapAnalysis/gap-analysis-fill-icon.svg";

import { ReactComponent as CrowdSourceIcon } from "svgs/light/crowSource/crowdsource-icon.svg";
import { ReactComponent as CrowdSourceFillIcon } from "svgs/light/crowSource/crowdsource-fill-icon.svg";

import { ReactComponent as WorkFromHomeIcon } from "svgs/light/work-from-home.svg";
import { ReactComponent as WorkFromHomeFillIcon } from "svgs/light/work-from-home-fill.svg";

import { ReactComponent as RupeeIcon } from "svgs/light/rupee.svg";


import { ReactComponent as ProfilingIcon } from "svgs/light/profiling.svg";
import { ReactComponent as ProfilingFillIcon } from "svgs/light/profiling-filled.svg";

import { PATH_MODULES } from "configs/pathName";

export const navBarCommon2 = [
  {
    title: "Employees Management",
    href: PATH_NAME.Employees,
    Icon: EmployeesIcon,
    selectedIcon: EmployeesFillIcon,
    label: DRAWER_MENU_LABEL.Employees,
    moduleAccess: PATH_MODULES[PATH_NAME.Employees],
  },
  {
    title: "Leave Management",
    href: PATH_NAME.LEAVE_MANAGEMENT,
    Icon: LeavesIcon,
    selectedIcon: LeavesFillIcon,
    label: DRAWER_MENU_LABEL.LeaveManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.LEAVE_MANAGEMENT],
  },
  {
    title: "Daily Attendance",
    href: PATH_NAME.DailyAttendance,
    Icon: attendanceIcon,
    selectedIcon: attendanceFillIcon,
    label: DRAWER_MENU_LABEL.Attendance,
    moduleAccess: PATH_MODULES[PATH_NAME.DailyAttendance],
  },
  {
    title: "Job Managment",
    href: PATH_NAME.JobManagement,
    Icon: JobManagementIcon,
    selectedIcon: JobManagementFillIcon,
    label: DRAWER_MENU_LABEL.Holidays,
    moduleAccess: PATH_MODULES[PATH_NAME.JobManagement],
  },

  {
    title: "Work Updates",
    href: PATH_NAME.ProjectManagement,
    Icon: WorkUpdateIcon,
    selectedIcon: WorkUpdateFillIcon,
    label: DRAWER_MENU_LABEL.ProjectManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.ProjectManagement],
  },

  {
    title: "Work Updates",
    href: PATH_NAME.ProjectUserManagement,
    Icon: WorkUpdateIcon,
    selectedIcon: WorkUpdateFillIcon,
    label: DRAWER_MENU_LABEL.ProjectUserManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.ProjectUserManagement],
  },

  // Delete permanently **************** only this
  // {
  //   title: "Task Management",
  //   href: PATH_NAME.TaskManagement,
  //   Icon: JobsOutlineIcon,
  //   selectedIcon: JobsFillIcon,
  //   label: DRAWER_MENU_LABEL.TaskManagement,
  //   moduleAccess: PATH_MODULES[PATH_NAME.TaskManagement],
  // },
  // Delete permanently **************** only this

  {
    title: "Tracker",
    href: PATH_NAME.GoalManagement,
    Icon: JobsOutlineIcon,
    selectedIcon: JobsFillIcon,
    label: DRAWER_MENU_LABEL.GoalManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.GoalManagement],
  },
  {
    title: "Transport Management",
    href: PATH_NAME.TransportManagement,
    Icon: Transport,
    selectedIcon: TransportFillIcon,
    label: DRAWER_MENU_LABEL.TransportManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.TransportManagement],
  },
  {
    title: "Schedule Management",
    href: PATH_NAME.ScheduleManagement,
    Icon: ScheduleManagement,
    selectedIcon: ScheduleManagementFill,
    label: DRAWER_MENU_LABEL.ScheduleManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.ScheduleManagement],
  },
  {
    title: "Employee Engagement",
    href: PATH_NAME.EmployeeEngagement,
    Icon: EmployeeIcon,
    selectedIcon: EmployeeFillIcon,
    label: DRAWER_MENU_LABEL.EmployeeEngagement,
    moduleAccess: PATH_MODULES[PATH_NAME.EmployeeEngagement],
  },
  {
    title: "Notice Board",
    href: PATH_NAME.NoticeBoard,
    Icon: NoticeBoardInactive,
    selectedIcon: NoticeBoardActive,
    label: DRAWER_MENU_LABEL.NoticeBoard,
    moduleAccess: PATH_MODULES[PATH_NAME.NoticeBoard],
  },
  {
    title: "Acxio Hubs",
    href: PATH_NAME.AcxioRooms,
    Icon: AcxioHubIcon,
    selectedIcon: AcxioHubFillIcon,
    label: DRAWER_MENU_LABEL.AcxioRooms,
    moduleAccess: PATH_MODULES[PATH_NAME.AcxioRooms],
  },
  {
    title: "Master Data",
    href: PATH_NAME.MasterData,
    Icon: FilesIcon,
    selectedIcon: FilesFillIcon,
    label: DRAWER_MENU_LABEL.MasterData,
    moduleAccess: PATH_MODULES[PATH_NAME.MasterData],
  },

  {
    title: "Inventory",
    href: PATH_NAME.InventoryManagement,
    Icon: InventoryIcon,
    selectedIcon: InventoryFillIcon,
    label: DRAWER_MENU_LABEL.InventoryManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.InventoryManagement],
  },
  {
    title: "Tickets",
    href: PATH_NAME.Tickets,
    Icon: TicketsIcon,
    selectedIcon: TicketsFillIcon,
    label: DRAWER_MENU_LABEL.Tickets,
    moduleAccess: PATH_MODULES[PATH_NAME.Tickets],
  },
  {
    title: "User Permissions",
    href: PATH_NAME.UserPermissions,
    Icon: UserPermissionIcon,
    selectedIcon: UserPermissionFillIcon,
    label: DRAWER_MENU_LABEL.UserPermissions,
    moduleAccess: PATH_MODULES[PATH_NAME.UserPermissions],
  },
  {
    title: "Access Management",
    href: PATH_NAME.AccessManagement,
    Icon: AccessIcon,
    selectedIcon: AccessFillIcon,
    label: DRAWER_MENU_LABEL.AccessManagement,
    moduleAccess: PATH_MODULES[PATH_NAME.UserPermissions],
  },
  {
    title: "Invites",
    href: PATH_NAME.Invites,
    Icon: UserInviteIcon,
    selectedIcon: UserInviteFillIcon,
    label: DRAWER_MENU_LABEL.Invites,
    moduleAccess: PATH_MODULES[PATH_NAME.Invites],
  },
  {
    title: "User Tracking",
    href: PATH_NAME.UserTracking,
    Icon: UserTrackingIcon,
    selectedIcon: UserTrackingFillIcon,
    label: DRAWER_MENU_LABEL.UserTracking,
    moduleAccess: PATH_MODULES[PATH_NAME.UserTracking],
  },
  {
    title: "Gap Analysis",
    href: PATH_NAME.GapAnalysis,
    Icon: GapAnalysisIcon,
    selectedIcon: GapAnalysisFillIcon,
    label: DRAWER_MENU_LABEL.GapAnalysis,
    moduleAccess: PATH_MODULES[PATH_NAME.GapAnalysis],
  },
  {
    title: "Natural Anchor Payments",
    href: PATH_NAME.CrowdsourcePayment,
    Icon: RupeeIcon,
    selectedIcon: RupeeIcon,
    label: DRAWER_MENU_LABEL.CrowdsourcePayment,
    moduleAccess: PATH_MODULES[PATH_NAME.CrowdsourcePayment],
  },
  // {
  //   title: "Crowdsource payment",
  //   href: PATH_NAME.CrowdsourcePayment,
  //   Icon: RupeeIcon,
  //   selectedIcon: RupeeIcon,
  //   label: DRAWER_MENU_LABEL.CrowdsourcePayment,
  //   moduleAccess: PATH_MODULES[PATH_NAME.CrowdsourcePayment],
  // },

  {
    title: "Anchor Stats",
    href: PATH_NAME.Crowdsource,
    Icon: CrowdSourceIcon,
    selectedIcon: CrowdSourceFillIcon,
    label: DRAWER_MENU_LABEL.Crowdsource,
    moduleAccess: PATH_MODULES[PATH_NAME.Crowdsource],
  },

  {
    title: "Work from Home",
    href: PATH_NAME.WorkFromHome,
    Icon: WorkFromHomeIcon,
    selectedIcon: WorkFromHomeFillIcon,
    label: DRAWER_MENU_LABEL.WorkFromHome,
    moduleAccess: PATH_MODULES[PATH_NAME.WorkFromHome],
  },
  {
    title: "Profiling",
    href: PATH_NAME.Profiling,
    Icon: ProfilingIcon,
    selectedIcon: ProfilingFillIcon,
    label: DRAWER_MENU_LABEL.Profiling,
    moduleAccess: PATH_MODULES[PATH_NAME.Profiling],
  },
];

export const navBarCommon = [
  {
    items: [
      // {
      //   title: "Acxio Hubs",
      //   href: PATH_NAME.AcxioRooms,
      //   Icon: AcxioHubIcon,
      //   selectedIcon: AcxioHubIcon,
      //   label: DRAWER_MENU_LABEL.AcxioRooms,
      //   moduleAccess: PATH_MODULES[PATH_NAME.AcxioRooms],
      // },
      {
        title: "Natural Anchor Payments",
        href: PATH_NAME.CrowdsourcePayment,
        Icon: RupeeIcon,
        selectedIcon: RupeeIcon,
        label: DRAWER_MENU_LABEL.CrowdsourcePayment,
        moduleAccess: PATH_MODULES[PATH_NAME.CrowdsourcePayment],
      },
      {
        title: "Employees Management",
        href: PATH_NAME.Employees,
        Icon: EmployeesIcon,
        selectedIcon: EmployeesFillIcon,
        label: DRAWER_MENU_LABEL.Employees,
      },
      {
        title: "Leave Management",
        href: PATH_NAME.LEAVE_MANAGEMENT,
        Icon: LeavesIcon,
        selectedIcon: LeavesFillIcon,
        label: DRAWER_MENU_LABEL.LeaveManagement,
      },
      {
        title: "Job Managment",
        href: PATH_NAME.JobManagement,
        Icon: JobsOutlineIcon,
        selectedIcon: JobsFillIcon,
        label: DRAWER_MENU_LABEL.Holidays,
      },
      {
        title: "Daily Attendance",
        href: PATH_NAME.DailyAttendance,
        Icon: attendanceIcon,
        selectedIcon: attendanceFillIcon,
        label: DRAWER_MENU_LABEL.Attendance,
      },
      {
        title: "Employee Engagement",
        href: PATH_NAME.EmployeeEngagement,
        Icon: EmployeeIcon,
        selectedIcon: EmployeeFillIcon,
        label: DRAWER_MENU_LABEL.EmployeeEngagement,
      },
      {
        title: "Inventory",
        href: PATH_NAME.InventoryManagement,
        Icon: InventoryIcon,
        selectedIcon: InventoryFillIcon,
        label: DRAWER_MENU_LABEL.InventoryManagement,
      },
      {
        title: "Tickets",
        href: PATH_NAME.Tickets,
        Icon: TicketsIcon,
        selectedIcon: TicketsFillIcon,
        label: DRAWER_MENU_LABEL.Tickets,
      },
      {
        title: "User Tracking",
        href: PATH_NAME.UserTracking,
        Icon: UserTrackingIcon,
        selectedIcon: UserTrackingFillIcon,
        label: DRAWER_MENU_LABEL.UserTracking,
      },
      {
        title: "Gap Analysis",
        href: PATH_NAME.GapAnalysis,
        Icon: GapAnalysisIcon,
        selectedIcon: GapAnalysisIcon,
        label: DRAWER_MENU_LABEL.GapAnalysis,
        moduleAccess: PATH_MODULES[PATH_NAME.GapAnalysis],
      },
    ],
  },
];
